document.addEventListener('DOMContentLoaded', function() {
  // Wait for the Loop widget to initialize
  setTimeout(initPriceSwitcher, 1000);
  
  function initPriceSwitcher() {
    // Find the price elements that need to be updated
    const regularPriceElement = document.querySelector('.price-item--sale');
    const compareAtPriceElement = document.querySelector('.price-item--regular');
    
    if (!regularPriceElement) {
      console.log('Price element not found, retrying...');
      setTimeout(initPriceSwitcher, 500);
      return;
    }
    
    // Save original prices
    const originalRegularPrice = regularPriceElement.textContent.trim();
    const originalComparePrice = compareAtPriceElement ? compareAtPriceElement.textContent.trim() : null;
    
    // Get subscription price from Loop widget
    const subscriptionPriceElement = document.querySelector('#loop-widget-purchase-option-price-id-6c819509c8de19993a9ff16dd38b8fb2fa1a7ee2');
    let subscriptionPrice = '$38.66 USD'; // Default fallback
    
    if (subscriptionPriceElement) {
      // Add USD to match format of original price
      subscriptionPrice = subscriptionPriceElement.textContent.trim() + ' USD';
    }
    
    // Function to update price display based on selection
    function updatePriceDisplay(forceSubscription = false) {
      // Check which option is selected, or force subscription view if requested
      const isSubscriptionSelected = forceSubscription || 
        document.querySelector('.loop-widget-purchase-option[data-loop-widget-selling-plan-group].loop-widget-purchase-option-selected') !== null;
      
      if (isSubscriptionSelected) {
        // Update to subscription price
        regularPriceElement.textContent = subscriptionPrice;
        // Optional: Hide compare price or update it to one-time price
        if (compareAtPriceElement) {
          compareAtPriceElement.textContent = originalRegularPrice;
        }
      } else {
        // Restore original prices
        regularPriceElement.textContent = originalRegularPrice;
        if (compareAtPriceElement) {
          compareAtPriceElement.textContent = originalComparePrice;
        }
      }
    }
    
    // Initialize with subscription price by default (even if not selected)
    updatePriceDisplay(true);
    
    // BONUS: If you also want to actually select the subscription option on page load:
    // Find the subscription option element
    const subscriptionOption = document.querySelector('.loop-widget-purchase-option[data-loop-widget-selling-plan-group]');
    if (subscriptionOption && !subscriptionOption.classList.contains('loop-widget-purchase-option-selected')) {
      // Programmatically click the subscription option
      // Uncomment the next line if you want this behavior
      // subscriptionOption.click();
    }
    
    // Listen for changes in the Loop widget
    document.addEventListener('click', function(e) {
      if (e.target.closest('.loop-widget-container')) {
        setTimeout(() => updatePriceDisplay(false), 100); // false = don't force subscription
      }
    });
    
    // Watch for class changes on the purchase options using MutationObserver
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class' && 
            mutation.target.classList.contains('loop-widget-purchase-option')) {
          updatePriceDisplay(false); // false = don't force subscription
        }
      });
    });
    
    // Observe all purchase options for class changes
    const purchaseOptions = document.querySelectorAll('.loop-widget-purchase-option');
    purchaseOptions.forEach(option => {
      observer.observe(option, { 
        attributes: true,
        attributeFilter: ['class'] 
      });
    });
  }
});